import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import DonutChart from '../SemiDonutChart';
import researchIcon from '../imgs/research_icon.png';

const VocationJuniorInterestAreaDescriptionPage = ({
  user,
  background,
  number
}) => {
  // sub-scales
  const { MA_SUB_SUM } = user;

  const MA_SUB = (parseInt(MA_SUB_SUM) / 30) * 100;
  // const MS_SUB = (parseInt(MS_SUB_SUM) / 30) * 100;
  // const ML_SUB = (parseInt(ML_SUB_SUM) / 30) * 100;
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h1>4. Aproximación al estudio</h1>
          <h2>4.1. Escalas de orientación al aprendizaje</h2>
          <p className='justified'>
            La motivación para el aprendizaje se refiere a las principales
            razones que te impulsan a estudiar y aprender en el colegio. Los y
            las estudiantes pueden tener distintos motivos para estudiar, pero
            algunos tipos de motivación pueden ser más útiles que otros, según
            los objetivos que cada uno/a se plantee para su nueva etapa escolar.
            En esta escala, bajo{' '}
            <strong>
              20% se considera un puntaje <em>bajo</em>, y 80% hacia arriba se
              considera un puntaje <em>alto</em>
            </strong>
            . A continuación te presentamos los puntajes que obtuviste en las
            escalas de motivación:
          </p>
          <br />
          <h3>4.1.1. Motivación al aprendizaje profundo</h3>
          <div className='graph-in-text'>
            <div className='chart-col'>
              <div
                className='ability-icon'
                style={{
                  height: 150,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={researchIcon}
                  alt='icon'
                  style={{ height: '100%', width: 'auto' }}
                />
              </div>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
              <DonutChart
                height={120}
                barSize={42}
                fontSize={36}
                data={[
                  {
                    id: 'MA_SUB',
                    label: MA_SUB.toFixed(0) + '%',
                    value: MA_SUB,
                    color: '#f7c033'
                  }
                ]}
              />
              <p className='justified'>
                Esta motivación se relaciona con disfrutar{' '}
                <strong>
                  aprender distintas cosas y valorar el aprendizaje en sí mismo
                </strong>
                , independientemente de si nos sacamos una buena o una mala
                nota. Las personas que tienen este tipo de motivación estudian
                porque les es interesante aprender algo nuevo o dominar nuevas
                habilidades.
              </p>
              <p className='justified'>
                Este tipo de motivación se relaciona con un aprendizaje más
                duradero en el tiempo, pero podemos correr el riesgo de
                “quedarnos pegados” estudiando algo que nos gusta mucho y
                descuidar otros temas, por lo que{' '}
                <strong>
                  es muy importante que se usen estrategias de estudio que te
                  permitan organizar bien tus tiempos para no dejar de lado
                  otros deberes. Por ejemplo, puedes organizar un horario
                  semanal de estudio o establecer tiempos definidos para dedicar
                  a cada asignatura, tanto a las que más te gustan como a las
                  que te cuestan un poco más.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationJuniorInterestAreaDescriptionPage;
